module.exports = __webpack_public_path__ + "img/image (3).01b9c7ef.png";